<template>
  <section class=" card">

    <header class="card-header">
      <p class="card-header-title">Custom Label White</p>
      <button class="card-header-icon">
      <span >
        <b-tag type="is-grey">White</b-tag>
      </span>
      </button>

    </header>
    <div class="card-content">
      <b-field label="Line 1 - Bold">
        <b-input v-model="line1" value="john@">
        </b-input>
      </b-field>


      <b-field grouped>
        <b-field label="Show Preview">
          <p class="control">
            <b-button class="button is-primary" @click="previewZPL">Preview</b-button>
          </p>
        </b-field>

        <b-field
            label="Amount"
            type="is-primary">
          <b-select v-model="amountOfLabels">
            <option :value="1">1</option>
            <option :value="2">2</option>
            <option :value="3">3</option>
            <option :value="4">4</option>
            <option :value="5">5</option>
            <option :value="6">6</option>
          </b-select>
        </b-field>
        <b-field label="Print">
          <b-button @click="printZPL">
            Print Tags
          </b-button>
        </b-field>
      </b-field>


    </div>

  </section>
</template>

<script>

import moment from "moment/moment";
const { Label, PrintDensity, PrintDensityName, Spacing, Text, FontFamily, FontFamilyName, Alignment, AlignmentValue} = require('jszpl');


export default {
  data() {
    return {
      amountOfLabels: 1,
      line1: '',
      line2: '',
      line3: '',
      line4: '',
      qr: '',

    };
  },
  methods: {

    previewZPL() {
      this.$emit("previewZPL", this.generateLabelZPL(), "4.02x3")
    },

    printZPL() {

      let res = []
      for (let i = 0; i < this.amountOfLabels; i++) {
        res.push(this.generateLabelZPL())
      }

      this.$emit("printZPL", res)
    },

    generateLabelZPL() {
      const label = new Label();
      label.printDensity = new PrintDensity(PrintDensityName['8dpmm']);
      label.width = 102;
      label.height = 76;
      label.padding = new Spacing(10);

      const text = new Text();
      label.content.push(text);
      text.fontFamily = new FontFamily(FontFamilyName.F);
      text.verticalAlignment = new Alignment(AlignmentValue.Center);
      text.horizontalAlignment = new Alignment(AlignmentValue.Center);
      text.text = this.line1;

      return label.generateZPL();

    },

  },
};
</script>
